import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Input,
  Alert as Alert2,
  ButtonGroup,
  ListGroup,
  ListGroupItem,
  Badge
} from "reactstrap";
import moment from "moment";
import Alert from "react-s-alert";
import _ from "lodash";
import './Site.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api, stringHelper, uiHelper, constant } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Link, Redirect } from "react-router-dom";
import { Schedule } from "../components";

const getEquipmentStatuses = () => api.fetch('Reference/EquipmentStatus').then(response => {
  return {
    equipmentStatusList: _.map(response.data, x => { return { value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const getEquipments = () => api.fetch('Reference/Equipments').then(response => {
  return {
    equipmentList: _.map(response.data, x => { return {...x, value: x.id, label: x.name }; })
  };
}).catch(x => console.error(x));
const emptyMaintenanceRecord = () => {
  return {
    id: -1,
    maintenanceDate: null,
    equipment: null,
    equipmentStatus: null,
    vendorMechanic: null,
    summaryOfMaintenance: '',
    recommendations: '',
    nextScheduledMaintenanceDate: null,
    scheduledMaintenance: null,
    equipmentDamageList: [],
    scheduledWorkId: null
  };
}

export default class EditMaintenanceRecord extends Component {
  static displayName = EditMaintenanceRecord.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      loading: true,
      addCount: 0,
      maintenanceRecordId: props.match && props.match.params && props.match.params.id
        ? props.match.params.id
        : null,
      equipmentId: props.match && props.match.params && props.match.params.equipmentId
        ? props.match.params.equipmentId
        : props.location.state && this.props.location.state.equipmentId
          ? this.props.location.state.equipmentId
          : null,
      scheduledWorkId: props.match && props.match.params && props.match.params.scheduledWorkId
        ? props.match.params.scheduledWorkId
        : props.location.state && this.props.location.state.scheduledWorkId
          ? this.props.location.state.scheduledWorkId
          : null,
      editMaintenanceRecord: null,
      equipmentStatusList: [],
      vendorMechanicList: [],
      equipmentList: [],
      equipmentDamageList: [],
      redirect: false,
      missingVendor: false,
      unresolvedDamage: null,
      damageId: this.props.location.state && this.props.location.state.damageId
        ? this.props.location.state.damageId
        : null,
      viewOnly:
        this.props.location.state && this.props.location.state.viewOnly
          ? this.props.location.state.viewOnly
          : false,
    };

    this.loadMaintenanceRecord = this.loadMaintenanceRecord.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.getVendorMechanics = this.getVendorMechanics.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.deleteScheduledWork = this.deleteScheduledWork.bind(this);
    this.onSelectDamageChange = this.onSelectDamageChange.bind(this);
  }

  componentDidMount() {
    Promise.all([getEquipmentStatuses(), getEquipments()]).then(response => {
      let newStatus = {};
      _.each(response, r => Object.assign(newStatus, r));
      this.setState(newStatus, () => { this.loadMaintenanceRecord(); });
    });
  }

  loadMaintenanceRecord() {
    if (this.state.maintenanceRecordId === "new") {
      let newRecord = emptyMaintenanceRecord();

      if (this.state.equipmentId !== null) {
        newRecord.equipment = stringHelper.resolveValueFromList(this.state.equipmentList, this.state.equipmentId)
        newRecord.scheduledWorkId = this.state.scheduledWorkId !== null ? this.state.scheduledWorkId : null;
      }
      this.setState({ editMaintenanceRecord: newRecord, loading: false }, () => {
        if (this.state.equipmentId !== null) {
          this.getVendorMechanics(newRecord.equipment.vendorId);
        }
      });

    } else {
      api.post("Equipment/GetMaintenanceRecord", this.state.maintenanceRecordId)
        .then(response => {
          if (response.data) {
            var maintenanceRecord = response.data;
            maintenanceRecord.equipmentStatus = stringHelper.resolveValueFromList(this.state.equipmentStatusList, maintenanceRecord.equipmentStatusId);
            maintenanceRecord.equipment = stringHelper.resolveValueFromList(this.state.equipmentList, maintenanceRecord.equipmentId);
            maintenanceRecord.vendorMechanic = { label: maintenanceRecord.vendorMechanicName, value: maintenanceRecord.vendorMechanicId };
            maintenanceRecord.maintenanceDate = maintenanceRecord.maintenanceDate ? moment(maintenanceRecord.maintenanceDate).toDate() : null;
            maintenanceRecord.nextScheduledMaintenanceDate = null;
            this.setState({
              editMaintenanceRecord: maintenanceRecord,
              loading: false,
            }, () => {
                this.getVendorMechanics(maintenanceRecord.vendorId);
            });
          }
        })
    }
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  getEquipmentDamages() {
    api.post('Equipment/GetUnResolvedEquipmentDamageRecords', parseInt(this.state.editMaintenanceRecord.equipment.id, 10))
      .then(response => {
        if (response.data) {
          const damagesList = _.map(response.data, d => {
            d.value = d.id;
            d.label = d.description;
            d.checked = false;
            return d;
          });
          this.setState({
            equipmentDamageList: damagesList
          }, () => {
            if (this.state.damageId) {
              this.onSelectDamageChange(stringHelper.resolveValueFromList(damagesList, this.state.damageId));
            }
          });
        }
      }).catch(x => console.error(x));
  }

  getVendorMechanics(vendorId) {
    if (vendorId !== null) {
      api.post('Reference/MechanicsByVendor', parseInt(vendorId, 10))
        .then(response => {
          if (response.data) {
            this.setState({
              vendorMechanicList: _.map(response.data, x => {
                return { ...x, value: x.id, label: x.name }
              }),
              missingVendor: false,
            }, () => {
                this.getEquipmentDamages();
                this.onDismiss();
            });
          }
        }).catch(x => console.error(x));
    } else {
      this.setState({
        isMessageVisible: !this.state.isMessageVisible,
        message: "There is no vendor associated with this equipment. Please go to equipment details and add a default vendor.",
        messageColor: "warning",
        missingVendor: true
      })
    }
  }

  onInputChange(e, fieldName) {
    this.setState({
      editMaintenanceRecord: { ...this.state.editMaintenanceRecord, [fieldName]: e.target.value }
    })
  }

  onDateChange(date, fieldName) {
    this.setState({
      editMaintenanceRecord: { ...this.state.editMaintenanceRecord, [fieldName]: date }
    })
  }

  onSelectChange(selection, fieldName) {
    let maintenanceRecord = Object.assign({}, this.state.editMaintenanceRecord);
    maintenanceRecord[fieldName] = selection;
    this.setState({
      editMaintenanceRecord: maintenanceRecord
    }, () => {
      if (fieldName === "equipment") {
        this.getVendorMechanics(selection.vendorId);
      }
    });
  }

  onToggleButtonChange(value, fieldName) {
    this.setState({
      editMaintenanceRecord: {
        ...this.state.editMaintenanceRecord,
        [fieldName]: !this.state.editMaintenanceRecord[fieldName]
      }
    });
  }

  onEdit() {
    this.setState({ viewOnly: false })
  }

  onCancel() {
    this.setState({
      editMaintenanceRecord: null
    });
  }

  isFormValid() {
    let warnings = [];
    if (!this.state.editMaintenanceRecord.maintenanceDate) {
      warnings.push("Please select an maintenance date");
    }
    if (!this.state.editMaintenanceRecord.equipment) {
      warnings.push("Please select an equipment");
    }
    if (!this.state.editMaintenanceRecord.vendorMechanic) {
      warnings.push("Please select a mechanic");
    }
    if (this.state.editMaintenanceRecord.summaryOfMaintenance === '') {
      warnings.push("Please enter maintenance summary");
    }

    this.setState({ message: (warnings.length ? warnings.join(", ") : null), messageColor: "danger", isMessageVisible: true });
    return warnings.length === 0;
  }

  onSave() {
    if (!this.isFormValid()) return;
    const maintenanceRecord = Object.assign({}, this.state.editMaintenanceRecord);
    let payload = {
      Id: maintenanceRecord.id,
      EquipmentId: maintenanceRecord.equipment ? parseInt(maintenanceRecord.equipment.value, 10) : null,
      SummaryOfMaintenance: maintenanceRecord.summaryOfMaintenance,
      Recommendations: maintenanceRecord.recommendations,
      MaintenanceDate: maintenanceRecord.maintenanceDate,
      VendorMechanicId: maintenanceRecord.vendorMechanic ? parseInt(maintenanceRecord.vendorMechanic.value, 10) : null,
      NextScheduledMaintenanceDate: maintenanceRecord.nextScheduledMaintenanceDate,
      ScheduledWorkId: maintenanceRecord.scheduledWorkId ? maintenanceRecord.scheduledWorkId : null,
      EquipmentDamageList: maintenanceRecord.equipmentDamageList.length > 0
        ? _.map(maintenanceRecord.equipmentDamageList, d => {
          return {
            Id: d.id,
            Description: d.description,
            EquipmentId: d.equipmentId
          };
        })
        : []
    }
    api.post("Equipment/SaveMaintenanceRecord", payload)
      .then(response => {
        if (response.data.success) {
          Alert.success("Maintenance record has been saved. You will be redirected momentarily.");
          this.timer = setTimeout(() => {
            this.setState({ redirect: true });
          }, 3000);
        } else {
          Alert.error("An error occured saving equipment details.")
        }
      }).catch(x => {
        Alert.error("An unexpected error occured.")
        console.error(x)
      });
  }

  deleteScheduledWork(scheduledWorkId) {
    if (!window.confirm(`Are you sure you'd like to the scheduled maintenance for this equipment?`)) return;

    api.delete(`Equipment/DeleteScheduledWork/${scheduledWorkId}`)
      .then(response => {
        if (response.data.success) {
          Alert.success("Scheduled maintenance was deleted for this equipment.")
          this.loadMaintenanceRecord();
        } else {
          Alert.error("An error occurred. Scheduled maintenance cannot be deleted at this time.")
        }
      }).catch(error => {
        Alert.error("There was an error deleting the scheduled maintenance for this equipment.")
      });
  }

  onSelectDamageChange(selection) {
    let record = Object.assign({}, this.state.editMaintenanceRecord);
    let damageList = this.state.equipmentDamageList.slice();
    let count = this.state.addCount + 1;

    const existingDamage = _.find(record.equipmentDamageList, d => { return d.value === selection.value })
    if (existingDamage === undefined) {
      let damage = _.find(damageList, d => { return d.id === selection.value });
      if (damage !== undefined) {
        record.equipmentDamageList.push({
          id: damage.id,
          description: damage.description,
          equipmentId: damage.equipmentId,
          value: damage.id,
          label: damage.description
        });
        damageList = _.reject(damageList, d => { return d.id === selection.value })
      }
    }
    this.setState({
      editMaintenanceRecord: record,
      addCount: count,
      equipmentDamageList: damageList
    });
  }

  onDamageRemove(damageId) {
    let record = Object.assign({}, this.state.editMaintenanceRecord);
    let damageList = this.state.equipmentDamageList.slice();
    let damage = _.find(record.equipmentDamageList, d => { return d.id === damageId });
    record.equipmentDamageList = _.reject(record.equipmentDamageList, d => { return d.id === damageId });
    damageList.push({
      id: damage.value,
      description: damage.description,
      value: damage.value,
      label: damage.label,
      equipmentId: damage.equipmentId
    })
    this.setState({
      editMaintenanceRecord: record,
      equipmentDamageList: damageList
    });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={`/equipment_maintenance_records`} />;
    }
    const {
      message,
      messageColor,
      editMaintenanceRecord,
      viewOnly,
      missingVendor,
      equipmentDamageList,
      unresolvedDamage
    } = this.state;
    return (
      <div className="ml-4 mr-4">
        {editMaintenanceRecord &&
          <React.Fragment>
            <Row className="mb-2">
              <Col><h5>{editMaintenanceRecord.id < 0 ? "New" : ""} Maintenance Record</h5></Col>
              {viewOnly ? null :
                <Col>
                  <ButtonGroup className="float-right">
                    <Button size="sm" className="cbdmdSecondary buttonGroupSpacing" onClick={() => this.onCancel()} tag={Link}
                      to={{
                        pathname: "/equipment_maintenance_records",
                        push: true,
                      }}
                    >Cancel</Button>
                  <Button size="sm" className="cbdmdPrimary buttonGroupSpacing" disabled={missingVendor} onClick={() => this.onSave()}>{editMaintenanceRecord.id > 0 ? "Update" : "Save"}</Button>
                  </ButtonGroup>
                </Col>
              }
            </Row>

            {this.state.message ? (
              <Alert2 color={messageColor} toggle={() => this.onDismiss()}>{message}</Alert2>
            ) : null}

            <Card className="p-2">
            <CardBody>
              {editMaintenanceRecord &&
              <Fragment>
                {
                  editMaintenanceRecord.equipment &&
                    <Row className="">
                      <Col className="float-right">
                        <Badge className="fontSize18" color={uiHelper.resolveStatusColor(editMaintenanceRecord.equipment.equipmentStatusName)}>{editMaintenanceRecord.equipment.equipmentStatusName}</Badge>
                      </Col>
                    </Row>
                }

                <Row>
                  <Col className="p-2" title="Details">
                    <Row className="mb-2">
                      <Col>Equipment:
                         <Select
                          closeMenuOnSelect={true}
                          value={editMaintenanceRecord.equipment}
                          options={this.state.equipmentList}
                          onChange={(e) => this.onSelectChange(e, "equipment")}
                          isDisabled={this.state.viewOnly || editMaintenanceRecord.id > 0}
                        />
                      </Col>
                      <Col>Mechanic:
                        <Select
                          closeMenuOnSelect={true}
                          value={editMaintenanceRecord.vendorMechanic}
                          options={this.state.vendorMechanicList}
                          onChange={(e) => this.onSelectChange(e, "vendorMechanic")}
                          isDisabled={!editMaintenanceRecord.equipment || missingVendor}
                        />
                    </Col>
                    <Col>Date:
                      <div>
                        <DatePicker
                          selected={editMaintenanceRecord.maintenanceDate}
                          className="form-control pageTitleItem float-right"
                          placeholderText="Select a date performed"
                          onChange={(e) => this.onDateChange(e, "maintenanceDate")}
                          disabled={missingVendor}
                        />
                      </div>
                    </Col>
                  </Row>

                  {editMaintenanceRecord && editMaintenanceRecord.equipment &&
                    <Row className="mb-2">
                      <Col>Reference Code:
                            <Input type="text" name="referenceCode" id="referenceCode" value={editMaintenanceRecord.equipment.referenceCode} disabled />
                      </Col>
                      <Col>Serial Number:
                            <Input type="text" name="serialNumber" id="serialNumber" value={editMaintenanceRecord.equipment.serialNumber} disabled />
                      </Col>
                      <Col>Model Number:
                            <Input type="text" name="modelNumber" id="modelNumber" value={editMaintenanceRecord.equipment.modelNumber} disabled />
                      </Col>
                    </Row>
                  }
                    <Row className="">
                    <Col>
                       <div>Summary of Maintenance:
                          <Input
                            type="textarea"
                            name="summaryOfMaintenance"
                            maxLength="500"
                            id="summaryOfMaintenance"
                            disabled={missingVendor}
                            onChange={(e) => this.onInputChange(e, 'summaryOfMaintenance')} value={editMaintenanceRecord.summaryOfMaintenance} disabled={this.state.viewOnly} />
                      </div>
                      <div>Recommenation:
                          <Input
                            type="textarea"
                            name="recommendations"
                            maxLength="500"
                            id="recommendations"
                            disabled={missingVendor}
                            onChange={(e) => this.onInputChange(e, 'recommendations')} value={editMaintenanceRecord.recommendations} disabled={this.state.viewOnly} />
                      </div> 
                    </Col>
                    <Col><span className="cbdmdBlueText">Current UnResolved Damages  </span> 
                      <Select
                        closeMenuOnSelect={true}
                        value={unresolvedDamage}
                        options={equipmentDamageList}
                        onChange={(e) => this.onSelectDamageChange(e)}
                        isDisabled={!editMaintenanceRecord.equipment || missingVendor}
                      />
                      {editMaintenanceRecord.equipmentDamageList && editMaintenanceRecord.equipmentDamageList.length > 0 &&
                        <ListGroup>
                        <ListGroupItem>
                         {editMaintenanceRecord.equipmentDamageList.map((damage, index) => (
                           <span className="mr-1" key={`damE-${index}${damage.id}`}>
                              <span className="ml-2" >{damage.description}</span>
                              <span className="ml-2"><FontAwesomeIcon icon="times" className="cbdmdDangerText" onClick={() => this.onDamageRemove(damage.id)}/></span>
                            </span>
                          ))}
                        </ListGroupItem>
                        </ListGroup>
                      } 
                      </Col>
                  </Row>

                    <Row className="mt-2">
                    <Col xs="3">
                      <Schedule
                        scheduledMaintenance={editMaintenanceRecord.scheduledMaintenance}
                        deleteScheduledWork={this.deleteScheduledWork}
                        onDateChange={this.onDateChange}
                        nextScheduledDate={editMaintenanceRecord.nextScheduledMaintenanceDate}
                        title={constant.maintenanceType.Maintenance.name}
                        disabled={missingVendor}
                      />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                </Fragment>
              }
              </CardBody>
            </Card>

          </React.Fragment>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EditMaintenanceRecord.js